import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import SciplayGames from "./sciplay-games"
import Stores from "./stores"

const Footer = () => {
  return (
    <footer>
      <div className='logos'>
        <h4 className='pb-[35px] text-center text-white text-[22px] md:text-[25px] font-bold'>
          SCIPLAY'S GAMES
        </h4>
        <SciplayGames showTitles={false} />
      </div>
      <div className='buttons flex flex-col justify-center items-center space-y-10 px-[10%] pt-20 pb-32 bg-black'>
        <div className=''>
          <Link to='/'>
            <StaticImage src='../images/logo.png' alt='' />
          </Link>
        </div>
        <Stores />
        <div className='flex flex-col justify-center items-center  space-y-10'>
          <div className='text-white text-2xl font-bold'>FOLLOW US</div>
          <div className='flex justify-center items-center space-x-5'>
            <a
              target='_blank'
              href='https://www.facebook.com/pages/category/casino/Quick-Hit-Slots-Community-1514614155455091/'
              className='block'
            >
              <StaticImage
                src='../images/socials/facebook.png'
                alt=''
                width={32}
              />
            </a>
            <a
              href='https://twitter.com/QuickHitSlots'
              className='block'
              target='_blank'
            >
              <StaticImage
                src='../images/socials/twitter.png'
                alt=''
                width={32}
              />
            </a>
            <a
              href='https://www.instagram.com/quickhitslots/'
              className='block'
              target='_blank'
            >
              <StaticImage
                src='../images/socials/instagram.png'
                alt=''
                width={32}
              />
            </a>
            <a
              href='https://www.youtube.com/channel/UCMy17pGosYA-POoOXaTrP7A'
              target='_blank'
              className='block'
            >
              <StaticImage
                src='../images/socials/youtube.png'
                alt=''
                width={32}
              />
            </a>
          </div>
        </div>
      </div>
      <div className='bottom flex flex-col xl:flex-row space-y-5 justify-between items-center text-gray-500 text-2xl'>
        <a href='https://www.sciplay.com' target='_blank'>
          <StaticImage src='../images/powered-by.png' alt='' />
        </a>
        <p className='text-center footer-bottom'>
          © Copyright {new Date().getFullYear()}. SciPlay Corporation. All Rights Reserved. |{" "}
          <a
            href='https://www.sciplay.com/terms-of-service#!/terms'
            target='_blank'
          >
            Terms of Service
          </a>{" "}
          |{" "}
          <a
            href='https://www.sciplay.com/terms-of-service#!/privacy'
            target='_blank'
          >
            Privacy Policy
          </a>{" "}
          |{" "}
          <a
            href='https://www.sciplay.com/terms-of-service#!/cookies'
            target='_blank'
          >
            Cookies
          </a>{" "}
          |{" "}
          <a
            href="https://www.sciplay.com/responsible-play"
            target="_blank"
          >
            Responsible Gaming
          </a>
        </p>
      </div>
    </footer>
  )
}

export default Footer
